

























































































































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'
import PageRequest from '@/store/entities/page-request'
import PurchaseOrderMedia from '../../../store/entities/purchase-order-media'
import CreatePurchaseOrderCheckInDto from '../../../store/entities/create-purchase-order-checkin'
import columnMedias from './purchase-order-medias-columns';
import moment from "vue-moment";
import AppConsts from '../../../lib/appconst';
Vue.use(require("vue-moment"));
class  PagePurchaseOrderCheckInRequest extends PageRequest{
}
@Component
export default class CreatePurchaseOrderCheckIn extends AbpBase{
    @Prop({type:Boolean,default:false}) value:boolean;
    pagerequest:PagePurchaseOrderCheckInRequest=new PagePurchaseOrderCheckInRequest();
    purchaseOrderCheckIn:CreatePurchaseOrderCheckInDto=new CreatePurchaseOrderCheckInDto();
    purchaseOrderMedias : Array<any> = new Array<any>();
    purchaseOrderMediasPerPage : Array<any> = new Array<any>();
    documentTypeCode : string = '';
    filterTotalCount :number=0;
    get documentTypes() {
        var re = this.$store.state.masterData.documentTypes;
        if(re.length > 0)
           this.documentTypeCode = re[0].id;
        return re;
    }
    async save() {
        this.$Modal.confirm({
            title:this.L('Tips'),
            content:this.L('Confirm.CreatePurchaseOrderCheckIn'),
            okText:this.L('Yes'),
            cancelText:this.L('No'),
            onOk:async()=>{
                var medias = this.purchaseOrderMedias.map((item) => {return {
                    documentTypeCode: item.documentTypeCode,
                    name: item.name,
                    url: item.url
                }});
                this.purchaseOrderCheckIn.poMedias = medias;
                await this.$store.dispatch({
                    type: "purchaseOrder/createPoCheckIn",
                    data: this.purchaseOrderCheckIn
                    }) 
                    .then(result => {
                        Util.showSuccessMsg(this,"Success.CreatePurchaseOrderCheckIn");
                        this.$root.$router.push({path: `/operations/view/purchaseorder-checkin/${result}`});
                });
            }
        });
    }

    onGoBack(){
        this.$root.$router.push({name: 'purchaseorder/:code', params: {code: this.purchaseOrderCheckIn.poCode}});
    }

    orderlist() {
        var startIndex = (this.currentPage - 1) * this.pageSize;
        var index = 0;
        this.purchaseOrderMedias.forEach(function(item) {
            item.fullUrl = Util.getAppUrlImage(item.url);
            item.orderNo = startIndex + index + 1;
            index++;
        });
    }

    get loading(){
        return this.$store.state.purchaseOrder.loading;
    }

    pageChange(page:number){
        this.$store.commit('purchaseOrder/setCurrentPage',page);
        this.getpage();
    }

    pagesizeChange(pagesize:number){
        this.$store.commit('purchaseOrder/setPageSize',pagesize);
        this.getpage();
    }

    get totalCount(){
        return this.filterTotalCount;
    }

    getpage(){
        this.pagerequest.maxResultCount=this.pageSize;
        this.pagerequest.skipCount=(this.currentPage-1)*this.pageSize;
    }

    get pageSize(){
        return this.$store.state.purchaseOrder.pageSize;
    }

    get currentPage(){
        return this.$store.state.purchaseOrder.currentPage;
    }

    async created(){
        this.purchaseOrderCheckIn.poCode = this.$root.$router.currentRoute.params.code;
        this.purchaseOrderMedias = new Array<any>();
        await this.$store.dispatch({
            type:'masterData/getDocumentTypes',
            param: {
                refTypeCode: AppConsts.refType.PurchaseOrder
            }
        });
    }

    remove(index: number) {
        this.$Modal.confirm({
            title: this.L('Tips'),
            content: this.L(`Confirm.RemovePurchaseOrderMedia`),
            okText: this.L('Yes'),
            cancelText: this.L('No'),
            onOk: async () => {
                    var item = this.purchaseOrderMedias[index];
                    var items = this.purchaseOrderMedias.filter(i => i.productId != item.productId);
                    this.purchaseOrderMedias = items;
            }
        })
    }

    columnMedias = columnMedias

    purchaseOrderCheckInRule = {
        poCode: [
            {
                required: true,
                message: this.L("Error.RequiredField", undefined, this.L("PoCode")),
                trigger: "blur"
            }
        ]
    };

    handleBeforeUpload(file) {
        const fileExt = file.name
        .split(".")
        .pop()
        .toLocaleLowerCase();


        if (fileExt === "jpep" || fileExt === "jpg" || fileExt === "png" || fileExt === "gif" || fileExt === "jfif") {
            let data = new FormData();
            data.append('file', file);

            this.$store.dispatch("purchaseOrder/uploadDocumentPoMedia", data)
            .then((res) => {
                var documentType = this.documentTypes.find(x => x.id == this.documentTypeCode);
                var newLine = {
                    orderNo :0,
                    documentTypeCode: this.documentTypeCode,
                    documentTypeName: documentType.name,
                    name: res.name,
                    url: res.url,
                };
                this.purchaseOrderMedias.push(newLine);
                this.orderlist();
            });
        }
    }
}
